// extracted by mini-css-extract-plugin
export default {"matter":"style_matter__YBJLb","content":"style_content__TXNNj","swiperWrapper":"style_swiperWrapper__0NIoJ"};